export const getBackendUrl = () => {
  const url = new URL("/api", window.location.href);
  url.port = process.env.REACT_APP_BACKEND_PORT; // 8080 local, 443 docker
  return url.href;
};

export const getWebsocketBackendUrl = () => {
  const url = new URL("/ws", window.location.href);
  url.port = process.env.REACT_APP_BACKEND_WEBSOCKET_PORT; 
  console.log("websocket url", url);
  return url.href;
};